module.exports = __webpack_public_path__ + "fo.svg?887df537109a7e673fc83012ffffbccd";